// Vue+Vuex importieren
import Vue from 'vue';
import Vuex from 'vuex';
import store from './stores/store'
Vue.use(Vuex);

// Bootstrap laden
import './plugins/bootstrap'

// Custom CSS+JS laden
import './plugins/custom'

// fetch polyfill
import 'whatwg-fetch'

// Plugins laden
// import './plugins/fontawesome';
import './plugins/element.js';

// App laden und Router setzen
import App from './App.vue';
import router from './router';
import core from '@/core/Core';
core.setRouter(router);
global.core = core;

// Dependencies laden
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */ )
import VeeValidate, { Validator } from 'vee-validate';
import ValidationDict from './assets/dictionary/validation';
import { isValidEmail, normalizeEmail, suggestKnownTypo, TYPO_PREFIX } from './utils/emailCheck';
Vue.use(VeeValidate, {
    locale: 'de',
    dictionary: ValidationDict,
    fieldsBagName: 'vfields'
});

// Eigene Regel für alle E-Mail-Felder. Sie prüft das Format über utils/emailCheck.js,
// dieselbe Datei läuft unverändert in den übrigen Portalen. Zusätzlich weist sie Domains
// ab, die nachweislich keinen MX-Eintrag haben (t-oline.de, gmali.com und weitere aus den
// Bounce-Protokollen) und nennt dabei die richtige Schreibweise. Ohne diese Prüfung wäre
// die Adresse formal gültig und würde trotzdem hart bouncen.
//
// Ein leeres Feld bleibt zulässig: ob eine Angabe Pflicht ist, entscheidet weiterhin
// allein 'required'. Die Meldungen stehen bei den anderen im Wörterbuch,
// assets/dictionary/validation.js.
//
// Element UI kennt kein v-text-field, deshalb gibt es hier nicht das eigene Feld mit
// anklickbarem Korrekturvorschlag wie in den Vuetify-Portalen. Der Vorschlag steht
// stattdessen im Text der Fehlermeldung.
Validator.extend('unisigns-email', (value) => {
    if (!normalizeEmail(value)) return true;
    if (!isValidEmail(value)) return false;

    const vorschlag = suggestKnownTypo(value);
    if (!vorschlag) return true;

    return { valid: false, data: { message: `${TYPO_PREFIX}${vorschlag}?` } };
});

// CSS laden
import 'swiper/dist/css/swiper.css'
// import './assets/global.scss'


Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')